import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RecommendedArtist from './RecommendedArtist';
import API from '../../API';
import Carousel from './Carousel';
import { Swiper, SwiperSlide } from 'swiper/react';
import { RefreshIcon,  } from '../../components/Icons';

import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/navigation/navigation.min.css';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';
import { l } from 'react-select/dist/index-fa0d9f94.esm';
SwiperCore.use([Pagination, Navigation]);

const RecommendedArtists = ({ recommended, fetchRecommended }) => {
  const { t } = useTranslation();

  const [freesubRecommended, setFreesubRecommended] = useState(
    JSON.parse(localStorage.getItem('feed.suggestions.filter')) === true
  );
  const [isActive, setActive] = useState(false);
  const [slideIndex, setSlideIndex] = useState(null);

  const refreshFilter = () => {
    setActive(!isActive);
    
    setTimeout(() => {
     setActive(false);
     if (freesubRecommended) {
       fetchRecommended('1')
     }
     else {
       fetchRecommended('0').then(() => {
        slideIndex.slideTo(0);
       });
     }
    }, 2000);
  };

  const filterArtists = () => {
 
    if (freesubRecommended) {
      fetchRecommended('0');
      localStorage.setItem('feed.suggestions.filter', false);

        setFreesubRecommended( false );

    
     
    } 
    else  {
      fetchRecommended('1');
      localStorage.setItem('feed.suggestions.filter', true);

        setFreesubRecommended(true);



    }
  };

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  };

  return (
    <div className={'d-flex flex-column pl-3 pr-3 recommended-artists-container'}>
      <>
        <div className={'d-flex recommended-artists-header'}>
          <p className={'artist-suggestion'}>{t('Suggestions')}</p>
          <div className="suggested-btns">
            
            <button id="rotateBtn" className={isActive ? 'rotate' : ''} onClick={() => refreshFilter()}>
              <RefreshIcon />
            </button>
          </div>
        </div>
        <Swiper
          slidesPerView={1}
          navigation={true}
          slidesPerColumn={2}
          pagination={pagination}
          spaceBetween={12}
          grabCursor={true}
          className="mySwiper" 
          onSwiper={(swiper) => setSlideIndex(swiper)}
          >
          {recommended.map((artist, index) => {
            return (
              <SwiperSlide  key={index}>
                <div key={`image_${index}`} className="position-relative uploaded-image-cont">
                  <RecommendedArtist key={index} artist={artist} />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="post-sub-line"></div>
      </>
    </div>
  );
};

export default RecommendedArtists;
